export default {
    errorCns: null,
    meianoite: {
        unidades: new Array(),
        txOcupacao: null
    },
    pacientesInternados: {
        mapaLeitos: null,
        pacienteInternado: null,
    },
    historicoInternacoes: {
        historico: null,
        error: null
    },
    historicoMovimentacao: {
        movimentacao: null
    },
    longaPermanencia: {
        ativos: null
    }
};
